import React, { useMemo } from 'react';
import { useModalDismiss } from './useModalDismiss';

const Modal = ({
  isOpen,
  onClose = () => {},
  children,
  className = '',
  zIndex = 'z-50',
  mobileMode = 'dialog',
}) => {
  useModalDismiss({ isOpen, onClose });

  const alignmentClass = mobileMode === 'sheet'
    ? 'items-end sm:items-center'
    : 'items-center';

  const mobileClass = useMemo(() => {
    if (mobileMode === 'fullscreen') {
      return 'max-md:mobile-fullscreen-panel';
    }
    if (mobileMode === 'sheet') {
      return 'max-md:w-full max-md:max-w-none max-md:max-h-[calc(100dvh-1rem)] max-md:rounded-t-[2rem] max-md:rounded-b-2xl max-md:overflow-hidden';
    }
    return '';
  }, [mobileMode]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 ${zIndex} flex ${alignmentClass} justify-center modal-backdrop safe-x px-4 py-6 sm:py-8`}
      onClick={onClose}
      role="presentation"
      data-modal-backdrop="true"
    >
      <div className={`${mobileClass} ${className}`} onClick={(event) => event.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
